import { render, staticRenderFns } from "./QualityAssuranceLabels.vue?vue&type=template&id=5f5f8dbd"
import script from "./QualityAssuranceLabels.vue?vue&type=script&lang=js"
export * from "./QualityAssuranceLabels.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports